import { TransparentButton } from '@libs/components';
import styled from 'styled-components';

export const ToolTipIconWrapper = styled(TransparentButton)`
  position: relative;
  width: 2rem;
  height: 2rem;
`;

export const ContentContainer = styled.div`
  padding: 0 2.4rem;
  padding-bottom: 2rem;
  max-width: 47.6rem;
  justify-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const InfoIcon = styled.img`
  width: 8rem;
  height: 8rem;
  margin-bottom: 2rem;
`;

export const DescriptionWrapper = styled.div`
  overflow: scroll;
  white-space: pre-wrap;
  max-height: calc(100vh - 30rem);
  margin-bottom: 2rem;

  ${({ theme }) => theme.media.laptop`
  
  max-height: 30rem;
  `}
`;
